export default class UnitDetails {
	constructor(button) {
		this.button = button;
		this.init();
	}

	init() {
		this.button.addEventListener('click', () => {
			const unsubscribeUrl = this.button.getAttribute('data-unsubscribe-url');
			if (unsubscribeUrl) {
				window.location.href = unsubscribeUrl;
			}
		});
	}
}
